export default "__VITE_ASSET__cfb79e8f__"